import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  getHistoryMaisEguByIdFailed,
  getHistoryMaisEguByIdSuccessful,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* getHistoryMaisEguById(action) {
  try {
    const pool = action.payload;
    const url = `${BACKEND_URL}/resources/applications/get-history`;
    const dataResponse = yield makeRequest(url, pool, action, 'POST', true);
    if (dataResponse.status === OK) {
      const response = yield dataResponse.json();
      const data = response?.resp?.getHistoryResponse?.info || [];
      yield put(getHistoryMaisEguByIdSuccessful({ data }));
      yield call(resolveActionPromise(action, { data }));
    } else {
      yield put(getHistoryMaisEguByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(getHistoryMaisEguByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
